import {
  MorphemeMnemonicsMeaningViewTabSections,
  useMorphemeMnemonicsMeaningViewTabScroll,
} from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.mnemonics._components.panel-content.views.meaning._lib.view-tab";
import { MorphemeMnemonicsMeaningViewTabFloatingActions } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.mnemonics._components.panel-content.views.meaning._sections.suggest-mnemonic";
import { View } from "@-/com.npmjs.react-native";

export function MorphemeMnemonicsMeaningViewTabPortraitView({
  extraBottomPadding = 0,
  showEditButton = true,
}: {
  extraBottomPadding?: number;
  showEditButton?: boolean;
}) {
  const layout = useMorphemeMnemonicsMeaningViewTabScroll({ extraBottomPadding, showEditButton });

  return (
    <View className="relative flex-1">
      <MorphemeMnemonicsMeaningViewTabSections layout={layout} />
      <MorphemeMnemonicsMeaningViewTabFloatingActions
        isEditing={layout.isEditing}
        onEditPress={layout.handleEditPress}
        showEditButton={layout.showEditButton}
      />
    </View>
  );
}
